import { Box } from "@mui/material";
import { ReactNode } from "react";

export const PrintPage = ({
  children,
  last = false,
}: {
  children: ReactNode;
  last?: boolean;
}) => (
  <Box
    sx={{
      breakAfter: last ? "auto" : "page",
      pageBreakAfter: last ? "auto" : "always", // legacy fallback
      breakInside: "avoid",
    }}
  >
    {children}
  </Box>
);